import React, { useMemo } from "react";
import { Slider, SliderSlide } from "../Slider/Slider";

export const ShipDeckPlansSlider: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  const wrapperSlides = useMemo(
    () =>
      React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return <SliderSlide>{child}</SliderSlide>;
        }
      }),
    [children]
  );

  return (
    <Slider variant="full" withMask={false}>
      {wrapperSlides}
    </Slider>
  );
};
